var map = {
	"./add-disabled.svg": "o1oE",
	"./add.svg": "HDdA",
	"./alert-icon.svg": "m73O",
	"./arrow-left.svg": "tqch",
	"./better-v.svg": "HofD",
	"./blacktrash.svg": "g8Jq",
	"./close-fat.svg": "0vT3",
	"./close.svg": "srjS",
	"./credit-card-outline.svg": "Ygno",
	"./exclamation-mark.svg": "mLDi",
	"./exclemation-mark-coral.svg": "JUSG",
	"./exclemation-mark-gray.svg": "5dUF",
	"./exclemation-mark-yellow.svg": "bpMv",
	"./flag-grey.svg": "tPnx",
	"./flag.svg": "bja1",
	"./group-5.svg": "CzIo",
	"./ic-close.svg": "aZ/1",
	"./icon-check-blue.svg": "QUYl",
	"./left-triangle.svg": "KQFn",
	"./lock-blue.svg": "RER/",
	"./lock-grey.svg": "KXcz",
	"./lock-outline.svg": "eunz",
	"./menu.svg": "f9hy",
	"./modal-close-blue.svg": "pzgY",
	"./modal-close-mustard.svg": "Iv2X",
	"./mode-edit.svg": "2UgK",
	"./notice-gray.svg": "KMUj",
	"./redtrash.svg": "JMc0",
	"./remove.svg": "ikHr",
	"./right-triangle.svg": "cnJ+",
	"./search-grey.svg": "JLqe",
	"./search.svg": "dZHa",
	"./success-icon.svg": "ihRI",
	"./trash.svg": "zbLZ",
	"./v-blue.svg": "tZyQ",
	"./v-outline.svg": "W9ot",
	"./v.svg": "lgce",
	"./warning-icon.svg": "vhV1"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UFRR";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons ^\.\/.*\.svg$
// module id = UFRR
// module chunks = 6